import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
declare var $;
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-contactus',
  templateUrl: './contactus.component.html',
  styleUrls: ['./contactus.component.css'],
})
export class ContactusComponent implements OnInit {
  url = environment.api_url;
  userObj = {
    fullName: '',
    emailId: '',
    contactQues: '',
    type: 'contact',
  };
  // Save contact
  contactObj = {
    fullName: '',
    emailId: '',
    question: '',
  };
  display = 'none';
  @Input() mVisible: boolean;
  @Output() closeModalEvent = new EventEmitter<boolean>();
  constructor(private http: HttpClient, private spinner: NgxSpinnerService) {}
  ngOnInit() {}
  send(event, myForm, formValid, modalId) {
    if (formValid) {
      this.contactObj.fullName = this.userObj.fullName;
      this.contactObj.emailId = this.userObj.emailId;
      this.contactObj.question = this.userObj.contactQues;

      const saveContactParam = new HttpParams().append(
        'contactObj',
        JSON.stringify(this.contactObj)
      );

      myForm.resetForm();
      const elementObj = document.getElementById(modalId);
      $('.modal-backdrop').css('display', 'none');
      $('body').css('padding-right', '0');
      this.closeModalEvent.emit(false);
      this.openModal();

      this.http
        .post(this.url + '/saveContact', saveContactParam)
        .subscribe((res: any) => {
          this.onCloseHandled();
          const saveContactResponse = res;
          $('#helpModel').modal('show');
        });
    }
  }
  closeContactModal(form) {
    form.resetForm();
  }

  omit_special_char(e) {
    var k;
    document.all ? (k = e.keyCode) : (k = e.which);
    return (
      (k > 64 && k < 91) ||
      (k > 96 && k < 123) ||
      k == 8 ||
      k == 32 ||
      (k >= 48 && k <= 57)
    );
  }

  closeResetModal() {
    $('.modal-backdrop').css('display', 'none');
    $('body').css('padding-right', '0');
  }
  // to open the modal
  openModal() {
    this.display = 'block';
  }
  // to close the modal
  onCloseHandled() {
    this.display = 'none';
  }
}
